/* Rotating ad (right column of the article page): changes picture every few seconds. */
(function () {
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function setup(root) {
    if (root.__advReady) return;
    root.__advReady = true;
    var slides = root.querySelectorAll('.adv-rot__slide');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('.adv-rot__dot');
    var ms = parseInt(root.getAttribute('data-interval'), 10) || 5000;
    var current = 0;
    var timer = null;

    function show(n) {
      current = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) {
        var on = k === current;
        slides[k].classList.toggle('is-active', on);
        slides[k].setAttribute('aria-hidden', on ? 'false' : 'true');
        if (on) slides[k].removeAttribute('tabindex');
        else slides[k].setAttribute('tabindex', '-1');
        if (dots[k]) dots[k].setAttribute('aria-current', on ? 'true' : 'false');
      }
    }

    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function start() {
      stop();
      if (reduced) return;
      timer = setInterval(function () {
        if (!document.body.contains(root)) {
          stop();
          return;
        }
        if (!document.hidden) show(current + 1);
      }, ms);
    }

    Array.prototype.forEach.call(dots, function (dot, k) {
      dot.addEventListener('click', function () {
        show(k);
        start();
      });
    });

    start();
  }

  function setupAll(scope) {
    var list = (scope || document).querySelectorAll('[data-adv-rotator]');
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }

  setupAll(document);

  if (!window.__advRotatorBound) {
    window.__advRotatorBound = true;
    document.addEventListener('shopify:section:load', function (e) {
      setupAll(e.target);
    });
  }
})();